import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  printedPickListsTitle: {
    description: 'Title for the printed pick lists section',
    defaultMessage: 'Printed Pick Lists',
    id: 'cY2ozS',
  },
  inventoryCounts: {
    description: 'Title for changing inventory count setting',
    defaultMessage: 'Show in-stock counts',
    id: 'AY96NW',
  },
  inventoryCountsDescription: {
    description: 'Description for inventory counts setting',
    defaultMessage: 'Show current inventory counts for each item',
    id: 'uG9c0H',
  },
  zeroQuantity: {
    description: 'Title for zero inventory count setting',
    defaultMessage: 'Show 0 quantity items',
    id: 'k2EECW',
  },
  orderNumbers: {
    description: 'Title for order numbers setting',
    defaultMessage: 'Show order number(s)',
    id: 'AiCas0',
  },
  orderNumbersDescription: {
    description: 'Description for order numbers setting',
    defaultMessage: 'Display which orders need each product',
    id: 'NOiJtR',
  },
  productImages: {
    description: 'Title for product images setting',
    defaultMessage: 'Print product images on Pick Lists',
    id: 'tpjCG2',
  },
  sortItems: {
    description: 'Title for sort items setting',
    defaultMessage: 'Sort items on pick list by:',
    id: 'lNy9GH',
  },
  sortItemsDescription: {
    description: 'Description for sort items setting',
    defaultMessage: 'Determines the sequence for items',
    id: 'E4Eh/s',
  },
  sortByItems: {
    description: 'Sort option for sorting by items',
    defaultMessage: 'Quantity',
    id: 'mCJ7qn',
  },
  sortBySKU: {
    description: 'Sort option for sorting by SKU',
    defaultMessage: 'SKU',
    id: 'haD9fB',
  },
  sortByName: {
    description: 'Sort option for sorting by name',
    defaultMessage: 'Name',
    id: '/ClbjD',
  },
  sortByWarehouseLocation: {
    description: 'Sort option for sorting by warehouse location',
    defaultMessage: 'Warehouse Location',
    id: 'NJqBQz',
  },
  sortByWarehouseLocationThenSKU: {
    description: 'Sort option for sorting by warehouse location then SKU',
    defaultMessage: 'Warehouse Location then SKU',
    id: 'b3vY0a',
  },
  summarizeBy: {
    description: 'Title for summarize by product setting',
    defaultMessage: 'Summarize by:',
    id: 'Ox41SV',
  },
  summarizeByDescription: {
    description: 'Description for summarize by setting',
    defaultMessage:
      'Allows you to consolidate the same items into a single row with the total quantity or list each item needed individually',
    id: 'LkIHt5',
  },
  groupBySKUAndName: {
    description: 'Option to group items by both SKU and name',
    defaultMessage: 'SKU and Name',
    id: 'paBVyv',
  },
  groupBySKU: {
    description: 'Option to group items by SKU only',
    defaultMessage: 'SKU',
    id: 'Kw3rfT',
  },
  groupByName: {
    description: 'Option to group items by name only',
    defaultMessage: 'Name',
    id: 'JagiyX',
  },
  listEachSeparately: {
    description: 'Option to not summarize items and list each individually',
    defaultMessage: 'Do not summarize',
    id: 'lFZFaW',
  },
  productImagesDescription: {
    description: 'Description for product images setting',
    defaultMessage: 'Allows you to show or hide item thumbnail images if they are available',
    id: 'Xf9PbA',
  },
  zeroQuantityDescription: {
    description: 'Description for zero quantity setting',
    defaultMessage: 'Allows you to show or hide line items if they have a quantity of 0',
    id: '1XiFbu',
  },
  hideItemOptions: {
    description: 'Title for hide item options setting',
    defaultMessage: 'Hide Item Options',
    id: '0NKCu1',
  },
  selectLocationSource: {
    description: 'Title for select location source setting',
    defaultMessage: 'Select location source:',
    id: '1g/AcE',
  },
  selectLocationSourceDescription: {
    description: 'Description for select location source setting',
    defaultMessage: 'Determines where ShipStation pulls your Warehouse Location information',
    id: 'JAppVt',
  },
  inventoryLocation: {
    description: 'Option for inventory location source',
    defaultMessage: 'Inventory Location',
    id: 'GzLGZI',
  },
  shippingLocations: {
    description: 'Option for shipping locations source',
    defaultMessage: 'Shipping Locations',
    id: 'ls6CZP',
  },
  skuSource: {
    description: 'Title for SKU source setting',
    defaultMessage: 'Select SKU Source',
    id: 'l7BxHs',
  },
  skuSourceDescription: {
    description: 'Description for SKU source setting',
    defaultMessage: 'Choose whether to display the SKU from your ShipStation Product Catalog or the SKU imported from your sales channel.',
    id: 'HXj1xS',
  },
  sellingChannel: {
    description: 'Option to use selling channel SKU',
    defaultMessage: 'Selling Channel',
    id: '2zgQX6',
  },
  shipstationProductCatalog: {
    description: 'Option to use ShipStation product catalog SKU',
    defaultMessage: 'ShipStation Product Catalog',
    id: 'J3ZLir',
  },
});
